import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';

const LAST_SEEN_THROTTLE_MS = 30000;
const lastSeenTimestamps = {};

export default {
  markMessagesRead: async ({ commit }, data) => {
    try {
      // Throttle: at most one update_last_seen per conversation every 30s
      const convId = data.id;
      const now = Date.now();
      if (
        lastSeenTimestamps[convId] &&
        now - lastSeenTimestamps[convId] < LAST_SEEN_THROTTLE_MS
      ) {
        return;
      }
      lastSeenTimestamps[convId] = now;

      const {
        data: { id, agent_last_seen_at: lastSeen },
      } = await ConversationApi.markMessageRead(data);
      setTimeout(
        () =>
          commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, { id, lastSeen }),
        4000
      );
    } catch (error) {
      // Handle error
    }
  },

  markMessagesUnread: async ({ commit }, { id }) => {
    try {
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
    } catch (error) {
      throwErrorMessage(error);
    }
  },
};
